/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, {
  createContext,
  useReducer,
  useContext,
  useEffect,
  useState,
} from 'react'
import { useHistory } from 'react-router-dom'
import jwtDecode from 'jwt-decode'
import { useTranslation } from 'react-i18next'
import { useIsAuthenticated, useMsal } from '@azure/msal-react'
import { ACCOUNT_INITIALISE, LOGIN, LOGOUT } from '../store/actions'
import accountReducer from '../store/accountReducer'
import axiosServices from '../utils/axios'
import { postDataService, getDataService } from '../services/back-end-service'
import {
  emptyLocalStorage,
  getLocalStorage,
  setLocalStorage,
  emptySessionStorage,
} from '../utils/localStorage'
import { ACCESS_TOKEN, REFRESH_TOKEN, SCOPE_MODE } from '../utils/constants'
import { isBo, onErrorTxt } from '../utils/CommonMethods'
import Spinner from '../components/Loader/Spinner'
import { url } from '../services/path-url'
import { BoUrl } from '../services/BO-path-url'
import { WebSocketContext } from './WebSocketContext'
import OtpScreen from './Context/OtpScreen'
import { createAuthHandlers } from './Context/Authhandlers'
import { useAuthInit, useMultiTabLogout } from './Context/Useauthhooks'
import newBg from '../assets/images/bg-images/new-bg-25.jpg'
import LoaderAllPage from '../components/Loader/LoaderAllPage'

const initialState = {
  isLoggedIn: false,
  isInitialised: false,
  isPendingCheck: true,
  isOtp: false,
  user: null,
  menu: [],
  admin: [],
  entity: [],
  scope: [],
  client_access: {},
}

const JWTContext = createContext({
  ...initialState,
  login: () => Promise.resolve(),
  oidc_login: () => Promise.resolve(),
  oidc_Bo_login: () => Promise.resolve(),
  logout: () => {},
  change_perimetre: () => Promise.resolve(),
})

export function JWTProvider({ children }) {
  const [state, dispatch] = useReducer(accountReducer, initialState)
  const websocket = useContext(WebSocketContext)
  const { i18n } = useTranslation()
  const history = useHistory()
  const { instance } = useMsal()
  const [isLoading, setIsLoading] = useState(false)

  const isAuthenticated = useIsAuthenticated()

  const {
    onFailure,
    onErrorAuth,
    onSuccessAuth,
    onSuccessMenu,
    onErrorAuthOtp,
  } = createAuthHandlers({ dispatch, history, i18n, websocket })

  useMultiTabLogout(dispatch)
  useAuthInit(dispatch, onSuccessMenu, onFailure)

  const login = async (username, password, lng, cb) => {
    const params = { username, password, encodedpassword: '', language: lng }
    try {
      const urlService = isBo() ? BoUrl.signin : url.auth.signin
      const response = await axiosServices.post(urlService, params, {
        'Content-Type': 'application/json',
      })
      if (cb) {
        cb(response)
      }
      if (response && response.data) {
        onSuccessAuth(response)
        return response.data
      }
    } catch (err) {
      onErrorAuth(err)
      if (cb) {
        cb(err)
      }
    }
  }

  const change_perimetre = (entity_id, scope_id) => {
    const onSuccessChange = async (data) => {
      emptyLocalStorage(true)
      emptySessionStorage()
      setLocalStorage(ACCESS_TOKEN, data.accesstoken)
      setLocalStorage(REFRESH_TOKEN, data.refreshtoken)
      if (websocket && websocket()) {
        websocket().send(
          `{"type":"authentification","token":"${data.accesstoken}"}`
        )
      }
      const decodedToken = jwtDecode(data.accesstoken)

      setLocalStorage('LANGUAGE', decodedToken.language)
      i18n.changeLanguage(decodedToken.language)

      setLocalStorage('username', decodedToken.name)
      setLocalStorage('appname', decodedToken.iss)
      setLocalStorage('customername', decodedToken.customer)
      setLocalStorage('entity_scope', decodedToken.entity_scope_name)
      setLocalStorage('idPerimetre', decodedToken.idperimetre)

      scope_id ? setLocalStorage(SCOPE_MODE, 1) : setLocalStorage(SCOPE_MODE, 0)
      dispatch({
        type: ACCOUNT_INITIALISE,
        payload: {
          isLoggedIn: true,
          menu: [],
          admin: [],
          entity: [],
          scope: [],
          client_access: {},
        },
      })
      getDataService(url.user.menu, onSuccessMenu, onFailure)
    }
    const executeChange = async () => {
      const params = { entity_id, scope_id }
      await postDataService(params, url.auth.switch, onSuccessChange, onFailure)
    }
    dispatch({
      type: LOGIN,
      payload: {
        isLoggedIn: true,
        isInitialised: false,
        menu: [],
        admin: [],
        entity: [],
        scope: [],
      },
    })

    executeChange()
  }

  const oidc_Bo_login = async (accessToken) => {
    try {
      const response = await axiosServices.get(BoUrl.oidc, accessToken)
      if (response.data) onSuccessAuth(response, true)
      dispatch({
        type: LOGIN,
        payload: {
          isLoggedIn: true,
          isInitialised: false,
          menu: [],
          admin: [],
          entity: [],
          scope: [],
        },
      })
      return response.data
    } catch (err) {
      onErrorAuth(err)
    }
  }

  const oidc_login = async (type, accessToken) => {
    dispatch({
      type: LOGIN,
      payload: {
        isLoggedIn: true,
        isInitialised: false,
        menu: [],
        admin: [],
        entity: [],
        scope: [],
      },
    })
    try {
      const response = await axiosServices.get(
        type === 1 ? url.auth.oidc : url.auth.okta,
        accessToken
      )
      if (response.data) onSuccessAuth(response)
      return response.data
    } catch (err) {
      onErrorAuth(err)
    }
  }

  const sendOtp = async (code) => {
    dispatch({
      type: LOGIN,
      payload: {
        isLoggedIn: true,
        isInitialised: false,
        isOtp: false,
        menu: [],
        admin: [],
        entity: [],
        scope: [],
      },
    })
    const tk = getLocalStorage(ACCESS_TOKEN)
    try {
      const response = await axiosServices.get(`${url.auth.totp}/${code}`, tk)
      if (response.data) onSuccessAuth(response)
      return response.data
    } catch (err) {
      onErrorAuthOtp(tk)
    }
  }

  const logout = async () => {
    const isSupAdmin =
      window.localStorage.getItem('super_admin') == 'super_admin'
    localStorage.setItem('logout', Date.now().toString())

    dispatch({ type: LOGOUT })
    emptyLocalStorage()
    emptySessionStorage()
    dispatch({
      type: ACCOUNT_INITIALISE,
      payload: {
        isLoggedIn: false,
        user: null,
      },
    })

    if (isAuthenticated) {
      instance.logoutRedirect({
        postLogoutRedirectUri:
          isBo() || isSupAdmin ? '/bo/auth/signin' : '/auth/signin',
      })
    }
  }

  const resetLogin = () => {
    dispatch({
      type: ACCOUNT_INITIALISE,
      payload: {
        isLoggedIn: false,
        user: null,
      },
    })
  }

  useEffect(() => {
    const initializeAuth = async () => {
      const token = getLocalStorage(ACCESS_TOKEN)
      if (!token) {
        setIsLoading(false)
        return
      }
      try {
        setIsLoading(true)
        await getDataService(
          url.auth.check_me,
          () => {
            setIsLoading(false)
          },
          () => {
            onErrorTxt(
              "Session expirée. Votre token d'authentification n'est plus valide. Veuillez vous reconnecter pour continuer."
            )
            setTimeout(() => {
              logout()
              setIsLoading(false)
            }, [2000])
          }
        )
      } catch (error) {
        onErrorTxt(
          "Session expirée. Votre token d'authentification n'est plus valide. Veuillez vous reconnecter pour continuer."
        )
        setTimeout(() => {
          logout()
          setIsLoading(false)
        }, [2000])
      } finally {
        setIsLoading(false)
      }
    }

    initializeAuth()
  }, [])

  if (!state.isInitialised) {
    if (state.isOtp) {
      return <OtpScreen onSubmit={sendOtp} onReset={resetLogin} />
    }
    return <Spinner />
  }

  if (isLoading) {
    return (
      <div
        className="auth-wrapper aut-bg-img-side container-fluid d-flex align-items-center justify-content-center"
        style={{
          backgroundImage: `url(${newBg})`,
          backgroundSize: 'cover',
          backgroundAttachment: 'fixed',
          backgroundPosition: 'center',
          height: '100vh',
          overflow: 'hidden',
        }}
      >
        <LoaderAllPage />
      </div>
    )
  }

  return (
    <JWTContext.Provider
      value={{
        ...state,
        dispatch,
        login,
        logout,
        change_perimetre,
        oidc_login,
        oidc_Bo_login,
        isLoading,
      }}
    >
      {children}
    </JWTContext.Provider>
  )
}

export default JWTContext

